module.exports = __webpack_public_path__ + "media/img/illustrations/icons/badge-bank-8f3c18b23d7d732a16f257aed17d63dc.svg";